import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HOMI_SETTINGS_CONFIG,
  HomiSettingsConfig,
} from './homi-settings.provider';
import {
  HomiSettings,
  EloSyncResults,
} from '@lyceo/shared/homi-settings/util-models';

@Injectable({
  providedIn: 'root',
})
export class HomiSettingsService {
  private readonly config: HomiSettingsConfig =
    inject<HomiSettingsConfig>(HOMI_SETTINGS_CONFIG);
  private readonly http: HttpClient = inject(HttpClient);

  public syncElo(pupilId: string): Observable<EloSyncResults> {
    const url: string = `${this.config.homiApiUrl}/api/pupils/${pupilId}/elo/sync`;
    const headers: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<EloSyncResults>(url, { headers });
  }

  public getHomiSettings(): Observable<HomiSettings> {
    const url: string = `${this.config.homiApiUrl}/api/settings`;
    let params: HttpParams = new HttpParams();
    if (this.config.eloRedirectUri) {
      params = params.set('redirectUri', this.config.eloRedirectUri);
    }
    const headers: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<HomiSettings>(url, { headers, params });
  }

  public getHomiSettingsByPupilId(pupilId: string): Observable<HomiSettings> {
    const url: string = `${this.config.homiApiUrl}/api/pupils/${pupilId}/settings`;

    const headers: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<HomiSettings>(url, { headers });
  }
}
